import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus, Minus } from "lucide-react";
import { Reveal } from "../Reveal";

const faqs = [
  {
    q: "How do engagements start?",
    a: "We begin with a 30-minute intro call to understand your product, team, and timeline. If it's a fit, we scope a paid discovery sprint before committing to build.",
  },
  {
    q: "What platforms do you ship?",
    a: "Native iOS (SwiftUI), native Android (Kotlin/Jetpack Compose), and React Native when cross-platform is the right call. Web is supported when it supports the product.",
  },
  {
    q: "Do you work with early-stage founders?",
    a: "Yes. We keep a small number of founder slots open each quarter with flexible engagement terms. Bring clarity on the problem; we'll bring the craft.",
  },
  {
    q: "How long does a typical project take?",
    a: "MVP builds land in 6–10 weeks. Design systems and larger product rebuilds run 3–6 months. Every schedule is backed by a written plan, not a pitch.",
  },
  {
    q: "What happens after launch?",
    a: "We stay on for a 4-week stabilization window by default. Ongoing retainers cover iteration, analytics, and feature expansion as the product grows.",
  },
];

function FAQ() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="section relative bg-levi-bg">
      <div className="container-xl grid lg:grid-cols-12 gap-12">
        <Reveal className="lg:col-span-4">
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-12 bg-levi-primary" />
            <span className="eyebrow">FAQ</span>
          </div>
          <h2 className="display-lg text-levi-text">
            Straight <br />
            <span className="text-levi-primary">answers.</span>
          </h2>
          <p className="mt-6 text-levi-muted">
            Still have questions? Write to us at{" "}
            <a href="mailto:tphuc.work@gmail.com" className="text-levi-text underline underline-offset-4 hover:text-levi-primary">
              tphuc.work@gmail.com
            </a>
            .
          </p>
        </Reveal>

        <Reveal className="lg:col-span-8" delay={0.1}>
          <div className="divide-y divide-levi-border border-y border-levi-border">
            {faqs.map((f, i) => {
              const isOpen = open === i;
              return (
                <div key={f.q}>
                  <button
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    className="w-full flex items-center justify-between gap-6 py-6 text-left cursor-pointer group"
                    aria-expanded={isOpen}
                  >
                    <span className="font-display text-xl md:text-2xl tracking-wider uppercase text-levi-text group-hover:text-levi-primary transition-colors">
                      {f.q}
                    </span>
                    <span className="flex-shrink-0 p-2 border border-levi-border group-hover:border-levi-primary transition-colors">
                      {isOpen ? <Minus size={16} /> : <Plus size={16} />}
                    </span>
                  </button>
                  <AnimatePresence initial={false}>
                    {isOpen && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
                        className="overflow-hidden"
                      >
                        <p className="pb-6 pr-12 text-levi-muted leading-relaxed">{f.a}</p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              );
            })}
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export default FAQ;
